import { render, staticRenderFns } from "./DoctorsNoteCard.vue?vue&type=template&id=b01fe37e&scoped=true&"
import script from "./DoctorsNoteCard.vue?vue&type=script&lang=js&"
export * from "./DoctorsNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsNoteCard.vue?vue&type=style&index=0&id=b01fe37e&prod&scoped=true&lang=css&"
import style1 from "./DoctorsNoteCard.vue?vue&type=style&index=1&id=b01fe37e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01fe37e",
  null
  
)

export default component.exports